//
//  Password Reset Reducer
//  CXA Apollo
//
//  Created on 24/11/2016.
//  Copyright (c) 2016 CXA. All rights reserved.
//

// Add ALL your actions into import list
import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_CLEAN,
} from "../actions/forgotPasswordActions";

const initialState = {
  response: {},
  submitting: false,
  submitted: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
      return { ...state, submitted: false, submitting: true };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        submitted: true,
        submitting: false,
        response: action.payload,
      };
    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        submitted: false,
        submitting: false,
        error: action.payload,
        response: null,
      };
    case FORGOT_PASSWORD_CLEAN:
      return {
        response: {},
        submitting: false,
        submitted: false,
        error: null,
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./reducers/forgotPasswordReducer.jsx